"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("@emotion/react");

var css_vars_ponyfill_1 = tslib_1.__importDefault(require("css-vars-ponyfill"));

var global = tslib_1.__importStar(require("./global"));

var loadDNS_1 = tslib_1.__importDefault(require("./loadDNS"));

loadDNS_1.default();
css_vars_ponyfill_1.default({
  include: '[data-emotion]',
  exclude: 'link',
  watch: true
});

exports.default = function () {
  return jsx_runtime_1.jsx(react_1.Global, {
    styles: [global.root, global.overrides]
  }, void 0);
};